//* Libraries imports
import { useState } from "react";

//* Utils imports
import { maskCPF, isValidCPF } from "@/utils/maskUtils";

//* Components imports
import Modal from "@/components/ui/Modal";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

type CpfModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (cpf: string) => void;
  loading: boolean;
  error: string | null;
};

export function CpfModal({
  open,
  onClose,
  onConfirm,
  loading,
  error,
}: CpfModalProps) {
  const [cpf, setCpf] = useState<string>("");
  const [localError, setLocalError] = useState<string | null>(null);

  const handleConfirm = () => {
    if (!isValidCPF(cpf)) {
      setLocalError("CPF inválido. Por favor, verifique os números.");
      return;
    }

    setLocalError(null);
    const onlyNumbers = cpf.replace(/\D/g, "");
    onConfirm(onlyNumbers);
  };

  const handleCpfChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const maskedValue = maskCPF(e.target.value);
    setCpf(maskedValue);
    if (localError) setLocalError(null);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Informe o CPF"
      actions={
        <div className="flex justify-end gap-2 p-2">
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancelar
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={loading || !cpf || cpf.length < 14}
          >
            {loading ? "Processando..." : "Confirmar"}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col gap-4 py-2 min-w-[300px]">
        <p className="text-bold text-gray-700">
          Voce não possui CPF cadastrado. Por favor, informe o CPF para
          prosseguir com a emissão do pagamento.
        </p>
        <div className="flex flex-col gap-2">
          <Input
            placeholder="000.000.000-00"
            value={cpf}
            onChange={handleCpfChange}
            disabled={loading}
            maxLength={14}
          />
          {(error || localError) && (
            <span className="text-red-500 text-xs">{error || localError}</span>
          )}
        </div>
      </div>
    </Modal>
  );
}
